// Tells the server what broke for the person (POST /api/telemetry/errors, backend utils/error_log.py),
// so the admin console shows it grouped: crashes an ErrorBoundary caught and errors nobody handled.
// At most a few reports per page load, each kind once; nothing about the person's content is sent,
// only the error, where it happened and the page's path.
import { clientPlatform } from './clientPlatform';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const MAX_REPORTS = 10;
const sent = new Set();

export function reportError(error, where) {
  try {
    const message = String(error?.message || error || '').slice(0, 2000);
    if (!message || !BACKEND_URL) return;
    const key = `${message}|${where || ''}`;
    if (sent.has(key) || sent.size >= MAX_REPORTS) return;
    sent.add(key);
    const token = localStorage.getItem('token');
    fetch(`${BACKEND_URL}/api/telemetry/errors`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        'X-Client-Platform': clientPlatform(),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        message: error?.name && !message.startsWith(error.name) ? `${error.name}: ${message}` : message,
        stack: String(error?.stack || '').slice(0, 8000) || undefined,
        where: where || undefined,
        url: window.location.pathname,
        version: process.env.REACT_APP_VERSION || undefined,
      }),
    }).catch(() => {});
  } catch {
    // reporting must never break the page
  }
}

export function installErrorReporter() {
  if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') return;
  window.addEventListener('error', (e) => reportError(e.error || e.message, 'window'));
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason;
    // A request the API refused is shown to the person already and is not a crash.
    if (reason?.isAxiosError || reason?.response) return;
    reportError(reason, 'promise');
  });
}
